import { render } from "./Scenario.vue?vue&type=template&id=0ec06cef"
import script from "./Scenario.vue?vue&type=script&lang=js"
export * from "./Scenario.vue?vue&type=script&lang=js"
script.render = render

export default script